import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderShield: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-shield, folder-security"><path d="M12.2812 19.25H2.75V3.75H10L12 6.75H21.25V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.75 11.75L15.25 13.3929V15.9554C15.25 17.6862 16.3631 19.2206 18.0084 19.7578L18.75 20L19.4916 19.7578C21.1369 19.2206 22.25 17.6862 22.25 15.9554V13.3929L18.75 11.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFolderShield;
